<template>
  <v-flex class="transferFunds fill-height" data-qa="internationalpayments-flex-1kuxn">
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
    <v-flex v-if="!reviewScreen" xs12 sm12 md12 lg12 xl12 data-qa="internationalpayments-flex-wfq5l">
      <v-navigation-drawer
        v-model="openPayee"
        :width="360"
        :close-on-click="false"
        absolute
        bottom
        right
        floating
        class="transferFunds--payeeList"
        data-qa="internationalpayments-navigation-drawer-c4j95a">
        <v-card height="100%" width="100%" data-qa="internationalpayments-card-nu12yc">
          <v-toolbar color="white" light data-qa="internationalpayments-toolbar-layke1h">
            <v-toolbar-title data-qa="internationalpayments-toolbar-title-vqk099">
              <v-list-item-title v-if="!enablePayeeForm" class="text-h6"
                 data-qa="internationalpayments-list-item-title-r6ygru">{{ $t("internationalPayments.selectPayeeLabel") }}
              </v-list-item-title>
              <v-list-item-title v-if="enablePayeeForm" class="text-h6"
                data-qa="internationalpayments-list-item-title-v1kfe9">
                {{ appSettingsNA.enableNominatedAccountFeatures ?
                  $t("internationalPayments.addPayeeHeadingNA") :
                  $t("internationalPayments.addPayeeHeading") }}
              </v-list-item-title>
            </v-toolbar-title>
            <v-spacer data-qa="internationalpayments-spacer-7q8408"></v-spacer>
            <v-btn @click.stop="onClosePayeeDrawer" icon data-qa="internationalpayments-btn-eyx4ia">
              <v-icon class="material-symbols-outlined" data-qa="internationalpayments-icon-40s2gn">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider data-qa="internationalpayments-divider-bc557l"  />
          <!-- Payees -->
          <v-list-item two-line v-if="!enablePayeeForm" data-qa="internationalpayments-list-item-q04rok">
            <v-list-item-content data-qa="internationalpayments-list-item-content-oye0wq">
              <v-list-item-title data-qa="internationalpayments-list-item-title-3srwi">
                <v-text-field data-qa="internationalpayments-text-field-aor50p"
                  v-model="searchPayee"
                  :label="$t('internationalPayments.payeeSearchLabel')"
                  :color="primaryColor"
                  prepend-inner-icon="mdi-magnify"
                  class="transferFunds--custom-textfield"
                  clearable
                  filled
                />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list v-if="!enablePayeeForm" two-line flat class="mt-n8" data-qa="internationalpayments-list-6hcee">
            <v-row v-if="isAddPayeePermitted.sepa" no-gutters justify="end" class="px-3" data-qa="internationalpayments-row-cypwffj">
              <v-btn v-if="enableSEPAAddNewPayee"
                @click="showAddPayeeForm"
                :color="primaryColor"
                dark
                class="text-capitalize"
                data-qa="internationalpayments-btn-c1wxm7">
              {{ appSettingsNA.enableNominatedAccountFeatures ?
                  $t("payee.nominatedAddNewPayeeBtn") :
                  $t("internationalPayments.addPayeeBtn") }}
              </v-btn>
            </v-row>
            <v-flex v-if="showFilters" class="mx-5 py-4" data-qa="internationalpayments-flex-55bx4a">
              <v-tabs
                :color="primaryColor"
                v-model="showLinkedAccounts"
                class="text-capitalize"
                data-qa="internationalpayments-tabs-jhiy8">
                <v-tab class="text-none font-weight-bold" data-qa="internationalpayments-tab-td3mf">
                  {{ $t("payee.linkedAccBtn") }}
                </v-tab>
                <v-tab class="text-none font-weight-bold" data-qa="internationalpayments-tab-mssx2n">
                  {{ $t("payee.payeeBtn") }}
                </v-tab>
              </v-tabs>
            </v-flex>
            <template v-if="payeeSearchFilter.length">
             <template v-for="(item, index) in payeeSearchFilter">
              <v-list-item
                :key="item.accountIdentification"
                @click="togglePayee(item)"
                :data-qa="`internationalpayments-list-item-8swhyfk-${index}`">
                <v-list-item-content :data-qa="`internationalpayments-list-item-content-ev68in-${index}`">
                  <v-list-item-title :data-qa="`internationalpayments-list-item-title-e3iysg-${index}`"
                    v-text="item.name"
                    class="text--primary"
                  />
                  <v-list-item-subtitle :data-qa="`internationalpayments-list-item-subtitle-7966a-${index}`"  v-text="item.accountIdentification" />
                  <v-list-item-subtitle :data-qa="`internationalpayments-list-item-subtitle-mys2e-${index}`"  v-text="`${item.bankIdentifier} (BIC Code)`" />
                </v-list-item-content>
              </v-list-item>
              <v-divider :data-qa="`internationalpayments-divider-dkpmy9-${index}`"
                v-if="showDivider(index, beneficiaryList)"
                :key="index"
              />
             </template>
            </template>
            <v-row v-else no-gutters justify="center" class="pa-2" data-qa="internationalpayments-row-wmr7a">
              {{ $t('payee.notAvailable')}}
            </v-row>
          </v-list>
          <v-list v-if="enablePayeeForm" data-qa="internationalpayments-list-kctudf">
            <v-list-item data-qa="internationalpayments-list-item-o6bv4o">
              <v-list-item-content data-qa="internationalpayments-list-item-content-xsr0y">
                <v-form ref="payeeForm" v-model="isPayeeFormValid" data-qa="internationalpayments-form-a4fee9">
                  <v-flex
                    v-if="isAddPayeeAddressEnabled"
                    data-qa="internationalpayments-flex-payeeTitle"
                    class="px-2 pb-3"
                  >
                    <span class="text-body-1 font-weight-bold">
                      {{ $t("payeeDetails.title") }}
                    </span>
                  </v-flex>
                  <v-text-field data-qa="internationalpayments-text-field-gtfv9m"
                    v-model="payeeForm.accountName"
                    :label="$t('internationalPayments.payeeAccountNameLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    :maxlength="payeeForm.payeeNameMaxLen
                      ? payeeForm.payeeNameMaxLen
                      : false"
                    filled
                    background-color="#f0eff7 !important"
                    class="customField pr-2 pt-0 pl-2"
                  />
                  <v-text-field data-qa="internationalpayments-text-field-4uw1r"
                    v-model="payeeForm.reEnteredToAccount"
                    @blur="
                      getBICFromIBAN(
                        payeeForm.reEnteredToAccount.replace(/\s+/g, '')
                      );
                      isAddPayeeAddressEnabled && setPayeeCountry()
                    "
                    :label="$t('internationalPayments.payeeAccNoLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    filled
                    background-color="#f0eff7 !important"
                    class="customField pr-2 pt-0 pl-2"
                    onCopy="return false"
                    onpaste="return false"
                    @keydown="$formatter.validateNumberInput($event, getIBAN());"
                    @input="formatIBAN()"
                  />
                  <v-text-field data-qa="internationalpayments-text-field-rasyb8"
                    v-model="payeeForm.sortCode"
                    :label="$t('internationalPayments.addNewPayee.bicCode')"
                    :color="primaryColor"
                    :rules="[rules.requiredWithNoErrRule]"
                    readonly
                    class="customField pr-2 pt-0 pl-2"
                  />
                  <v-flex xs12 sm12 md12 lg12 xl12
                    v-if="isAddPayeeAddressEnabled"
                    data-qa="internationalpayments-flex-payeeAddressForm"
                  >
                    <PayeeAddressDetails
                      v-model="payeeAddressFormData"
                      :isPayeeDrawer="true"
                      @form-validity-change="isAddPayeeAddressFormValid = $event"
                    />
                  </v-flex>
                  <!--Whose account? own/others - enable the radio buttons only when nominated account feature is disabled.
                      if nominated account feature is ON then user can add only own accounts-->
                  <v-flex class="px-2 font-weight-bold" xs12 sm12 md12 lg12 xl12 v-if="!appSettingsNA.enableNominatedAccountFeatures" data-qa="internationalpayments-flex-3v4x16">
                    {{$t('addNewPayee.whoseBankAccount')}}
                    <v-radio-group
                      :rules="[fieldRules]"
                      v-model="isOwnAccLinked"
                      row
                      class="font-weight-regular"
                      data-qa="internationalpayments-radio-group-gmvrl3">
                      <v-radio
                        :label="$t('addNewPayee.ownAccount')"
                        value="own"
                        :color="secondaryColor"
                        data-qa="internationalpayments-radio-xdtpbk"></v-radio>
                      <v-radio
                        :label="$t('addNewPayee.othersAccount')"
                        value="others"
                        :color="secondaryColor"
                        data-qa="internationalpayments-radio-iyj9m9"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <SupplementaryDocuments
                    v-if="isSupplementaryDocumentEnabled"
                    v-model="payeeSupplementaryDocuments"
                    :required="supplementaryConfig.required"
                    :maxFileSizeInMB="supplementaryConfig.maxFileSizeInMB"
                    :maxFileUploadCount="supplementaryConfig.maxFileUploadCount"
                    :validFileTypes="supplementaryConfig.validFileTypes"
                    :compactView="true"
                    class="pt-2"
                  />
                  <v-row v-if="isAddPayeePermitted.sepa" no-gutters class="pa-2" data-qa="internationalpayments-row-hp4148">
                    <v-btn
                      @click="onAddPayee"
                      :color="primaryColor"
                      :disabled="isAddPayeeDisabled"
                      class="white--text text-capitalize py-2 px-4"
                      data-qa="internationalpayments-btn-of79d">
                    {{ appSettingsNA.enableNominatedAccountFeatures ?
                        $t("addNewPayee.ownAccountTitle") :
                        $t("addNewPayee.addPayeeBtn") }}
                    </v-btn>
                  </v-row>
                </v-form>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-navigation-drawer>

      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="internationalpayments-flex-6ws45">
        <Loader v-show="loaderEnabled" />
        <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="internationalpayments-layout-kldtm3">
          <v-flex
            xs12
            sm12
            md12
            lg12
            xl12
            :style="{ background: dashboardGradient, height: '180px' }"
            data-qa="internationalpayments-flex-2lvan6j">
            <v-container class="transferFunds--title-padding" data-qa="internationalpayments-container-73kqgj">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="internationalpayments-flex-a3oafr">
                <v-row no-gutters data-qa="internationalpayments-row-a954kl">
                  <v-layout row wrap class="pb-2" data-qa="internationalpayments-layout-v1wobi">
                    <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="internationalpayments-flex-4qlaxi">
                      <v-row justify="end" data-qa="internationalpayments-row-1h9g7">
                        <v-avatar :tile="false" size="35" color="white" data-qa="internationalpayments-avatar-lhx04">
                          <v-icon :color="primaryColor" data-qa="internationalpayments-icon-ib50ks">mdi-sync</v-icon>
                        </v-avatar>
                      </v-row>
                    </v-flex>
                    <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="internationalpayments-flex-gua89">
                      <v-row no-gutters data-qa="internationalpayments-row-dsqfch">
                        <font class="text-h5 font-weight-light white--text">
                          {{ $t("internationalPayments.title") }}</font
                        >
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-flex>
            </v-container>
          </v-flex>
        </v-layout>
        <!-- Start Payment Transfer Form-->
        <v-flex
          xs12
          sm12
          md12
          lg10
          xl10
          class="transferFunds--content-padding transferFunds--overlayCardFlex"
          data-qa="internationalpayments-flex-jckyg">
          <v-layout row wrap class="transferFunds--content-padding" data-qa="internationalpayments-layout-cplnt">
            <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="internationalpayments-flex-w5amyc">
              <v-card data-qa="internationalpayments-card-eiaych">
                <!-- Tab control - Registered / Quick -->
                <v-tabs
                  v-if="SEPAQuickPayEnabled"
                  v-model="currentTab"
                  :color="primaryColor"
                  class="pl-9 pt-4"
                  @change="onTabChanged"
                  data-qa="internationalpayments-tabs-f5jl46">
                  <v-tabs-slider
                    :color="primaryColor"
                    data-qa="internationalpayments-tabs-slider-xth9ze"></v-tabs-slider>
                  <v-tab
                    v-for="(item, i) in transferOptionsTabs"
                    :key="item"
                    class="text-capitalize font-weight-bold"
                    :data-qa="`internationalpayments-tab-4j0v8-${i}`"
                  >
                    {{ item }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="currentTab" :color="primaryColor" data-qa="internationalpayments-tabs-items-65bu09">
                  <!--Tab idx 0 - Registered Account-->
                  <v-tab-item data-qa="internationalpayments-tab-item-fyyrup">
                    <v-container class="pt-4" data-qa="internationalpayments-container-4qhe6">
                      <v-tabs
                        v-model="paymentMode"
                        :color="primaryColor"
                        class="pl-6"
                        @change="onPaymentModeChanged"
                        data-qa="internationalpayments-tabs-6ktojp">
                        <v-tab @click="resetPage" data-qa="internationalpayments-tab-wicw2l">
                          <font class="text-capitalize">{{
                            $t("internationalPayments.firstSubSection")
                          }}</font>
                        </v-tab>
                        <v-tab v-if="enableRecurringPaymentsOption" @click="resetPage" data-qa="internationalpayments-tab-awarh">
                          <font class="text-capitalize">{{
                            $t("internationalPayments.secondSubSection")
                          }}</font>
                        </v-tab>
                      </v-tabs>
                      <v-form
                        ref="form"
                        v-model="isFormValid"
                        :lazy-validation="false"
                       data-qa="internationalpayments-form-3p0fpf">
                        <v-layout row justify-space-between data-qa="internationalpayments-layout-22uvcd">
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="internationalpayments-flex-7yk49j">
                            <PaymentSourceSelect
                              v-model="form.selectedAccount"
                              @input="handleSourceInput"
                              @change="verifyNominatedAccount"
                              :items="filteredSourceAccounts"
                              :label="
                                this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? $t('internationalPayments.selectAccountLabelIban') : $t('internationalPayments.selectAccountLabel')
                              "
                              :error="isFormAccounts"
                              :error-messages="isFormAccounts ? $t('internationalPayments.accountsError') : ''"
                              :rules="[rules.requiredRule || !isFormAccounts]"
                            />
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="internationalpayments-flex-067qol">
                            <v-text-field
                              v-model="payeeList"
                              @focus="listPayee"
                              :color="primaryColor"
                              :rules="[rules.requiredRule || !isFormAccounts]"
                              :label="$t('internationalPayments.selectPayeeLabel')"
                              :hint="
                                payeeAccountName || selectedPayeeSortCode
                                  ? `${payeeAccountName} | ${selectedPayeeSortCode}`
                                  : ''
                              "
                              persistent-hint
                              filled
                              readonly
                              append-icon="mdi-chevron-right"
                              class="transferFunds--custom-textfield"
                             data-qa="internationalpayments-text-field-ngzo7o"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="internationalpayments-flex-kkdmm">
                            <v-text-field
                              v-model="transferAmount"
                              @input="
                                verifyBalance();
                                restrictDecimal($event);
                              "
                              @keypress="numbersOnly"
                              :label="$t('internationalPayments.amountLabel')"
                              :prefix="
                                $formatter.currency.getCurrencySymbol(
                                  SEPAPaymentTemplate.currency
                                )
                              "
                              :hint="`${$t('internationalPayments.maxAmountLimit')} - ${formatAmount(
                                SEPAPaymentTemplate.transactionLimit,
                                SEPAPaymentTemplate.currency
                              )}`"
                              :color="primaryColor"
                              :rules="[
                                rules.requiredAmountRule,
                                rules.isAccBalanceValid,
                                rules.isLimitValid,
                              ]"
                              :error="isBalValid ()"
                              :error-messages="
                                isBalValid ()
                                  ? $t('internationalPayments.fundsError')
                                  : ''
                              "
                              :class="[
                                'transferFunds--custom-textfield custom-amount' ,
                                'transferFunds--amountCurrencySymbolDefault',
                                transferAmount && transferAmount.length
                                  ? false
                                  : 'transferFunds--amountCurrencySymbol',
                              ]"
                              filled
                              persistent-hint
                              type="number"
                             data-qa="internationalpayments-text-field-zfsj0k"></v-text-field>
                          </v-flex>
                          <v-flex
                            v-if="!oneTimePayment"
                            xs12
                            sm12
                            md6
                            lg6
                            xl6
                            class="px-6 pt-3"
                           data-qa="internationalpayments-flex-ssmhsf">
                            <v-select
                              v-model="paymentFrequency"
                              :label="
                                $t('internationalPayments.frequencyDaysLabel')
                              "
                              :items="frequencyDays"
                              :color="primaryColor"
                              :rules="[rules.requiredRule]"
                              autocomplete
                              return-object
                              filled
                              item-text="state"
                              item-value="val"
                              item-key="val"
                              max-height="auto"
                              data-qa="paymentFrequency"
                              class="transferFunds--custom-textfield"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" v-if="!oneTimePayment" data-qa="internationalpayments-flex-5koudr">
                            <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              offset-y
                              transition="scale-transition"
                              min-width="290px"
                             data-qa="internationalpayments-menu-66ttr">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-on="on"
                                  v-model="repeatFromDate"
                                  :label="
                                    oneTimePayment
                                      ? $t(
                                          'transferfunds.quickPaymentDateLabel'
                                        )
                                      : $t('transferfunds.paymentDateLabel')
                                  "
                                  :color="primaryColor"
                                  :rules="[rules.requiredRule]"
                                  filled
                                  readonly
                                  data-qa="fromDate"
                                  append-icon="mdi-calendar"
                                  class="transferFunds--custom-textfield"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="repeatFormattedDate"
                                @input="menu = false"
                                :allowed-dates="allowedDates"
                                :min="repeatMinAllowedDate"
                                :color="primaryColor"
                                filled
                                data-qa="fromDate"
                                @change="repeatUpdateDate"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md6
                            lg6
                            xl6
                            class="px-6 pt-3"
                            v-if="!oneTimePayment"
                           data-qa="internationalpayments-flex-lyv1vd">
                            <v-text-field
                              v-model="frequencyMonths"
                              @keydown="filterKey"
                              :label="$t('internationalPayments.selectTimes')"
                              :rules="[rules.requiredRule, rules.minValue, rules.maxValue]"
                              :color="primaryColor"
                              filled
                              onCopy="return false"
                              onpaste="return false"
                              type="number"
                              class="transferFunds--custom-textfield"
                              data-qa="internationalpayments-text-field-uzbl7"></v-text-field>
                          </v-flex>
                          <v-flex v-if="oneTimePayment" xs12 sm12 md6 lg6 xl6 class="px-7 pt-4" data-qa="internationalpayments-flex-02o9ua">
                            <v-menu
                              v-model="menuOneTimePayment"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              offset-y
                              transition="scale-transition"
                              min-width="290px"
                              data-qa="internationalpayments-menu-r1mcua">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-on="on"
                                  v-model="formattedDateOTP"
                                  :label="$t('transferfunds.quickPaymentDateLabel')"
                                  :color="primaryColor"
                                  :rules="[rules.requiredRule]"
                                  filled
                                  readonly
                                  data-qa="fromDate"
                                  append-icon="mdi-calendar"
                                  class="transferFunds--custom-textfield"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="formattedDate"
                                @input="menuOneTimePayment = false"
                                :allowed-dates="allowedDates"
                                :min="fromDate"
                                :color="primaryColor"
                                filled
                                data-qa="fromDate"
                                @change="repeatUpdateDateOTP"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="internationalpayments-flex-h0kim">
                            <v-text-field
                              v-model="transferNote"
                              :label="$t('internationalPayments.noteLabel')"
                              :color="primaryColor"
                              :rules="
                                transferNote
                                  ? [rules.transferNoteValidation]
                                  : [rules.requiredRule]
                              "
                              filled
                              class="transferFunds--custom-textfield"
                              :maxlength="transferNoteMaxLength"
                              data-qa="internationalpayments-text-field-j1sznf"></v-text-field>
                          </v-flex>
                          <v-container class="px-7" data-qa="internationalpayments-container-289dtw">
                            <SupplementaryDocuments
                              v-if="oneTimePayment"
                              v-show="true"
                              v-model="supplementaryDocuments"
                              :compact-view="$vuetify.breakpoint.xs"
                            />
                          </v-container>
                        </v-layout>
                        <v-layout row justify-space-between data-qa="internationalpayments-layout-507g1k">
                          <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="internationalpayments-flex-b3msdw">
                            <v-btn
                              @click="onNextButton"
                              :color="primaryColor"
                              :disabled="
                                !isFormValid || isFormAccounts || isAccountBalance || !hasValidDocuments
                              "
                              elevation="2"
                              class="text-capitalize ma-2 white--text py-2 px-4"
                              data-qa="internationalpayments-btn-v93jv4">{{
                                $t("internationalPayments.reviewPaymentBtn")
                              }}</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-tab-item>
                  <!--Tab idx 1 - Quick Payment-->
                  <v-tab-item v-if="SEPAQuickPayEnabled" data-qa="internationalpayments-tab-item-zeqz0f">
                    <v-container class="pt-4" data-qa="internationalpayments-container-9jix8q">
                      <v-form
                          ref="quickPaymentForm"
                          v-model="quickPayment.isFormValid"
                          :lazy-validation="false"
                          data-qa="internationalpayments-form-lw474n">
                        <v-layout row justify-space-between data-qa="internationalpayments-layout-dm7q39">
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="internationalpayments-flex-gsjhyr">
                            <PaymentSourceSelect
                               v-model="form.quickSelectedAccount"
                               @input="verifyAccount"
                               :items="filterARI"
                               :label= "enableIBANAccountNumberDisplay? $t('internationalPayments.fromAcctIBAN') : $t('internationalPayments.selectAccountLabel')"
                               :error="isFormAccountsQP"
                               :error-messages="isFormAccountsQP ? $t('internationalPayments.accountsError') : ''"
                               :rules="[rules.requiredRule || !isFormAccountsQP]"
                               return-object
                            />
                          </v-flex>
                          <!--Payee Account Name -->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="internationalpayments-flex-pf8sl">
                              <v-text-field
                                v-model="quickPayment.toAcctName"
                                :color="primaryColor"
                                :label="
                                  $t('internationalPayments.toAcctName')
                                "
                                :rules="[rules.requiredRule]"
                                filled
                                class="transferFunds--custom-textfield"
                                data-qa="internationalpayments-text-field-uvd8fb"></v-text-field>
                          </v-flex>
                          <!--To Account (IBAN)-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="internationalpayments-flex-wm5di9">
                              <v-text-field
                                v-model="quickPayment.toAccount"
                                :label="$t('internationalPayments.selectPayeeLabel')"
                                :color="primaryColor"
                                :error="quickPayment.invalidIBAN"
                                :error-messages="
                                  quickPayment.invalidIBAN
                                  ? $t('internationalPayments.deriveBICError')
                                  : ''
                                "
                                :rules="[
                                  rules.requiredRule,
                                  rules.isAlphaNumericRule,
                                ]"
                                :maxlength="quickPayment.toAccMaxLength"
                                filled
                                onCopy="return false"
                                onpaste="return false"
                                class="transferFunds--custom-textfield"
                                @keydown="
                                  $formatter.validateNumberInput($event)
                                "
                                @input="clearBICError"
                                @blur="getBICFromIBAN"
                                data-qa="internationalpayments-text-field-eme08c"></v-text-field>
                          </v-flex>
                          <!--BIC Code - readonly - Fill up based on To Account -->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-5" data-qa="internationalpayments-flex-k3eovn">
                              <v-text-field
                                v-model="quickPayment.bicCode"
                                :color="primaryColor"
                                :label="
                                  $t('internationalPayments.addNewPayee.bicCode')
                                "
                                :rules="[rules.requiredRule]"
                                readonly
                                max-height="auto"
                                class="transferFunds--custom-disabled-textfield"
                                ref="quickPayBicCode"
                                data-qa="internationalpayments-text-field-vaesuw"></v-text-field>
                          </v-flex>
                          <!--Amount-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="internationalpayments-flex-6tv419h">
                              <v-text-field
                                v-model="quickPayment.transferAmount"
                                @input="
                                  verifyBalance();
                                  restrictDecimal($event);
                                "
                                @keypress="numbersOnly"
                                :label="$t('internationalPayments.amountLabel')"
                                :prefix="
                                  $formatter.currency.getCurrencySymbol(
                                    SEPAPaymentTemplate.currency
                                  )
                                "
                                :hint="`${$t('internationalPayments.maxAmountLimit')} - ${formatAmount(
                                  SEPAPaymentTemplate.transactionLimit,
                                  SEPAPaymentTemplate.currency
                                )}`"
                                :color="primaryColor"
                                :rules="[
                                  rules.requiredAmountRule,
                                  rules.isQuickPaymentBalanceValid,
                                  rules.isQPLimitValid,
                                ]"
                                :class="[
                                  'transferFunds--custom-textfield custom-amount',
                                  'transferFunds--amountCurrencySymbolDefault',
                                  quickPayment.transferAmount && quickPayment.transferAmount.length
                                    ? false
                                    : 'transferFunds--amountCurrencySymbol',
                                ]"
                                filled
                                persistent-hint
                                type="number"
                                ref="qpAmountField"
                                data-qa="internationalpayments-text-field-cegs0u"></v-text-field>
                            </v-flex>
                            <!--Payment Date - Readonly - Always gets the current date-->
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-5" data-qa="internationalpayments-flex-yq520q">
                              <v-text-field
                                v-model="quickPayment.formattedDate"
                                :color="primaryColor"
                                :label="
                                  $t('internationalPayments.quickPaymentDateLabel')
                                "
                                :rules="[rules.requiredRule]"
                                readonly
                                class="transferFunds--custom-disabled-textfield"
                                data-qa="internationalpayments-text-field-3r5kaa"></v-text-field>
                            </v-flex>
                            <!--Remarks (Optional) -->
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="internationalpayments-flex-rqro0a">
                              <v-text-field
                                v-model="quickPayment.transferNote"
                                :label="$t('internationalPayments.noteLabel')"
                                :color="primaryColor"
                                :rules="
                                  quickPayment.transferNote
                                    ? [
                                        rules.transferNoteValidation
                                      ]
                                    : [rules.requiredRule]
                                "
                                filled
                                class="transferFunds--custom-textfield"
                                data-qa="internationalpayments-text-field-k6hqvc"></v-text-field>
                            </v-flex>
                            <v-container class="px-7" data-qa="internationalpayments-container-u1dikc">
                              <SupplementaryDocuments
                                v-model="supplementaryDocuments"
                                :compact-view="$vuetify.breakpoint.xs"
                              />
                            </v-container>
                        </v-layout>
                        <!--Review Payment Button-->
                        <v-layout row justify-space-between data-qa="internationalpayments-layout-w0ezy">
                          <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="internationalpayments-flex-ipj1ot">
                            <v-btn
                              class="text-capitalize ma-2 white--text py-2 px-4"
                              :color="primaryColor"
                              :disabled="
                                !quickPayment.isFormValid ||
                                quickPayment.isAccountBalance ||
                                !hasValidDocuments
                              "
                              elevation="2"
                              @click="onNextButton"
                              data-qa="internationalpayments-btn-fw6exq">{{
                                $t("internationalPayments.reviewPaymentBtn")
                              }}</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-tab-item>
                  <!--End Quick Payment form-->
                </v-tabs-items>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex v-else data-qa="internationalpayments-flex-p2tp1d">
      <InternationalPaymentsReview
        @sepaPaymentSuccessfull="initiateSEPAtransfer"
        @reset_isInitiateSepaFailed="isInitiateSepaFailed = false"
        :config="{ payload }"
        :display="{ viewOnly }"
        :isInitiateSepaFailed="isInitiateSepaFailed"
        :isQuickPay= "currentTab===1"
      />
    </v-flex>
    <!-- Add new payee OTP section -->
    <Modal
      v-if="enableOTPToAddPayee && showOTPScreen"
      @cancel="onOtpModalClose"
      :config="modalConfig.otp"
    >
      <span slot="modalContent" data-qa="internationalpayments-span-2p9djb">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <Modal
      v-if="showSuccessDialog"
      :config='getPaymentSuccessDialogConfig'
      @btn1Action="handleCreateNewTransfer"
      @btn2Action="handleGotoDashboard"
      @btn3Action="downloadPaymentProofEnabled"
    >
    </Modal>
    <PaymentFailureDialog
      :show="failureDialog.show"
      :retry="retry"
      :error-list="retry ? failureDialog.errorList : []"
      @goBack="handleGoBack"
      @retryTransfer="handleRetryTransfer"
      @cancelTransfer="handleCancelTransfer"
    />
  </v-flex>
</template>

<script>
import store from '@/core/store'
import '@/styles/pages/login/login.scss'
import '@/styles/pages/transferFunds.scss'
import OtpInput from '@/components/common/OtpInput.vue'
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'
import { mask } from 'vue-the-mask'
import event from '@/util/event'
import moment from 'moment'
import SEPAPaymentTemplate from '@/plugins/SEPAconfig'
import Loader from '../../../../components/common/Loader.vue'
import SupplementaryDocuments from '../../InterBankPayments/common/SupplementaryDocuments.vue'
import { getSepaRequestBody } from './InternationaPaymentsUtil'
import PaymentFailureDialog from '../common/PaymentFailureDialog.vue'
import PaymentSourceSelect from '../../../common/PaymentSourceSelect.vue'
import InternationalPaymentsReview from './InternationalPaymentsReview.vue'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'
import { v4 as uuidv4 } from 'uuid'
import PayeeAddressDetails from '../../../payee/PayeeAddressDetails.vue'

const YMD = 'YYYY-MM-DD'

export default {
  name: 'InternationalPayment',
  components: {
    Loader,
    OtpInput,
    InternationalPaymentsReview,
    Modal: () => import('@/components/common/Modal.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    SupplementaryDocuments,
    PaymentFailureDialog,
    PaymentSourceSelect,
    PayeeAddressDetails
  },
  mixins: [smeRolesMixin],
  directives: { mask },
  data () {
    return {
      valid: true,
      reviewScreen: false,
      isInitiateSepaFailed: false,
      isFormValid: false,
      isPayeeFormValid: false,
      isFormAccounts: false,
      isFormAccountsQP: false,
      isAccountBalance: false,
      loaderEnabled: false,
      openPayee: false,
      enablePayeeForm: false,
      menu: false,
      menuOneTimePayment: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      corporateId: '',
      userCorporates: [],
      corpName: '',
      defaultCorporateCode: '',
      userId: '',
      search: '',
      searchPayee: '',
      listOfAccounts: [],
      payload: {},
      viewOnly: {},
      isLeavingRoute: false,
      selectedAccount: undefined,
      selectedAccountNumber: '',
      selectedAccountNumberCurrency: '',
      payeeAccount: '',
      payeeAccountName: '',
      selectedPayee: null,
      searchPayeeList: '',
      transferAmount: [],
      paymentFrequency: '',
      frequencyMonths: '',
      transferNote: '',
      payeeList: '',
      paymentDate: '',
      selectedPayeeSortCode: '',
      fromDate: moment().format(YMD),
      todaysDate: moment().format(YMD),
      repeatFromDate: moment().format(YMD),
      repeatMinAllowedDate: moment().format(YMD),
      repeatFormattedDate: '',
      formattedDate: '',
      formattedDateOTP: moment().format(YMD),
      minAllowedDate: moment().format(YMD),
      displayDateFormat: this.$appSettings.defaultConfigurations.dateFormat.uiFormat,
      enableOTPToAddPayee:
        this.$appSettings.defaultConfigurations.enableOTPToAddPayee,
      enableRecurringPaymentsOption:
        this.$appSettings.defaultConfigurations.payments.enableRecurringPaymentsOption,
      otpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
		  enableSEPAAddNewPayee:  this.$appSettings.defaultConfigurations.enableSEPAAddNewPayee,
      SEPAQuickPayEnabled: this.$appSettings.defaultConfigurations.SEPAQuickPayEnabled,
      linkedNominatedAccDetails: {},
      isNominatedAccount: false,
      showOTPScreen: false,
      isLogout: false,
      paymentMode: 0,
      showLinkedAccounts: 0,
      isTransferComplete: false,
      internationalPaymentCharges: undefined,
      SEPAPaymentTemplate,
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        successModal: {
          enabled: false,
          persistent: true,
          dataListTranslation: 'transferfunds',
          title: this.$t('paymentSuccessDialog.transferInitiated'),
          btn1Label: this.$t('paymentSuccessDialog.button.newTransfer'),
          btn2Label: this.$t('paymentSuccessDialog.button.gotoDashboard'),
          width: 700
        }
      },
      isQuickPay: false,
      currentTab: 0,
      transferOptionsTabs: [
        this.$t('internationalPayments.registeredAccTitle'),
        this.$t('internationalPayments.quickPaymentTitle')
      ],
      quickPayment: {
        formattedDate: this.$formatter.formatDate(moment().format(YMD)),
        bicCode: '',
        toAcctName: '',
        toAccount: '',
        transferAmount: [],
        isAccountBalance: false,
        fromDate: moment().format(YMD),
        selectedAccount: undefined,
        selectedAccountNumber: '',
        transferNote: '',
        invalidIBAN: false,
        isFormValid: false,
        toAccMaxLength: this.$appSettings.defaultConfigurations.fundTransferQuickPayToAccMaxlengthIBAN // get this value from config - confirm what is the expected length
      },
      payeeForm: {
        sortCode: '',
        toAccount: '',
        accountName: '',
        reEnteredToAccount: '',
        payeeNameMaxLen:
          this.$appSettings.defaultConfigurations.payeeNameMaxlength.interBank
      },
      frequencyDays: [
        { state: 'Daily', val: 'DAILY' },
        { state: 'Weekly', val: 'WEEKLY' },
        { state: 'Fortnightly', val: 'FORTNIGHTLY' },
        { state: 'Monthly', val: 'MONTHLY' },
        { state: 'BI-Monthly', val: 'BI-MONTHLY' },
        { state: 'Quarterly', val: 'QUARTERLY' },
        { state: 'Half-Yearly', val: 'HALF-YEARLY' },
        { state: 'Yearly', val: 'YEARLY' }
      ],
      enableEBAVCheckForAddPayee: this.$appSettings.defaultConfigurations.enableEBAVCheckForAddPayee,
      bankName: this.$appSettings.applicationSettings.bankName,
      beneficiaryList: [],
      noteRules: [
        (v) => !!v || 'Note is required',
        (v) => (v && v.length >= 5) || 'Note must be greater than 5 characters'
      ],
      fieldRules: (v) => !!v || 'Required Field',
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredWithNoErrRule: (v) => Boolean(v) || '',
        requiredAmountRule: (v) =>
          (Boolean(v) && !!v.length) || this.$t('errors.common.amountRequired'),
        lengthRange: (value, min, max) =>
          (value && (value.length > min || value.length < max)) ||
          `Enter atleast ${min} characters`,
        minLength: (value, min) =>
          (value && value.length >= min) || `Enter atleast ${min} characters`,
        minValue: (v) => v >= 2 || this.$t('transferfunds.numberOfPaymentsMinValidation'),
        maxValue: (v) => v <= 10 || this.$t('transferfunds.numberOfPaymentsMaxValidation'),
        isAlphaNumericRule: (v) => {
          if (v) {
            return (
              new RegExp('^([^ !@#\\$%\\^&\\*][a-zA-Z0-9]*)$', 'g').test(v) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        },
        numberTypeCheck: (v) =>
          new RegExp('^\\d+(.\\d\\d?)?$').test(v) ||
          this.$t('errors.common.invalidInput'),
        transferNoteValidation: (v) =>
          new RegExp('^[a-zA-Z0-9 \\.\\-\\,\\+\\(\\)\\|\\:\\?\\/\\s]*$').test(v) ||
          this.$t('errors.common.invalidChar'),
        isQuickPaymentBalanceValid: (v) => {
          let tempValue = v
          if (tempValue) {
            tempValue = tempValue.toString().replace(',', '.')
            return tempValue && tempValue > 0
              ? !this.quickPayment.isAccountBalance ||
              this.$t('transferfunds.fundsError')
              : new RegExp('^0*(.0*)$').test(tempValue)
                ? this.$t('errors.common.minAmountError')
                : false
          } else {
            return false
          }
        },
        isAccBalanceValid: (v) =>
          v && v > 0
            ? !this.isAccountBalance ||
              this.$t('internationalPayments.fundsError')
            : new RegExp('^0*(.0*)$').test(v) || v < 0
              ? this.$t('errors.common.minAmountError')
              : false,
        isLimitValid: () =>
          this.transferAmount <= this.SEPAPaymentTemplate.transactionLimit ||
          this.$t('domesticPayments.limitError'),
        isQPLimitValid: () =>
          this.quickPayment.transferAmount <= this.SEPAPaymentTemplate.transactionLimit ||
          this.$t('domesticPayments.limitError')
      },
      transferNoteMaxLength: '',
      isOwnAccLinked: null,
      appSettingsNA: this.$appSettings.defaultConfigurations.nominatedAccounts,
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      successResponse: '',
      showSuccessDialog: false,
      currentDate: moment().format(YMD),
      supplementaryDocuments: [],
      payeeSupplementaryDocuments: [],
      endToEndId: '',
      failureDialog: {
        show: false,
        errorList: [],
        retryCount: 0
      },
      form: {
        selectedAccount: null,
        quickSelectedAccount: null
      },
      isAddPayeePermitted: {
        sepa: false
      },
      transactionId: '',
      paymentTime: '',
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload,
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      payeeAddressFormData: null,
      isAddPayeeAddressFormValid: true,
      payeeAddrType: '',
      payeeAddrLine: '',
      payeeStrtNm: '',
      payeeBldgNb: '',
      payeePostCd: '',
      payeeCity: '',
      payeeCtrySubDvsn: '',
      payeeCtry: ''
    }
  },
  async created () {
    this.transferNoteMaxLength = this.SEPAPaymentTemplate.remarksMaxLength
    const self = this
    const tomorrow = new Date()
    tomorrow.setDate(new Date().getDate() + 1)
    this.repeatMinAllowedDate = moment(tomorrow).format(YMD)
    this.repeatFormattedDate = moment(tomorrow).format(YMD)
    this.repeatFromDate = this.$formatter.formatDate(this.repeatFormattedDate)
    this.formattedDate = this.$formatter.formatDate(this.fromDate)
    this.formattedDateOTP = this.$formatter.formatDate(this.fromDate)
    this.formattedDate = this.fromDate
    this.quickPayment.formattedDate = this.$formatter.formatDate(this.todaysDate)
    if (self.$route.params && self.$route.params.accountsList) {
      self.listOfAccounts = self.$route.params.accountsList
    } else {
      await self.getListofAccounts()
    }
    if (self.$route.params && self.$route.params.accountNumber) {
      self.selectedAccountNumber = self.$route.params.accountNumber
      self.quickPayment.selectedAccountNumber =
        self.$route.params.accountNumber
      self.selectedAccountNumberCurrency = self.$route.params.currency || ''
      self.verifyAccount()
    }
    if (self.$route.params && self.$route.params.beneficiaryAccount) {
      self.payeeAccount = self.$route.params.beneficiaryAccount
    }
    if (this.$route.params && this.$route.params.payeeAccountNumber) {
      this.payeeAccountName = this.$route.params.payeeAccountNumber
      this.payeeAccount = this.$route.params.payeeAccountNumber
      this.payeeList = this.$route.params.payeeName
      this.selectedPayeeSortCode = this.$route.params.payeeSortCode
      this.selectedPayee = this.$route?.params?.payeeAccount
      this.getExistingPayeeList()
    }
    if (this.$route?.params?.payeeAccount) {
      const payeeDetails = this.$route?.params?.payeeAccount
      if (payeeDetails.addressType) this.payeeAddrType = payeeDetails.addressType
      if (payeeDetails.addressLine) this.payeeAddrLine = payeeDetails.addressLine
      if (payeeDetails.street) this.payeeStrtNm = payeeDetails.street
      if (payeeDetails.buildingNumber) this.payeeBldgNb = payeeDetails.buildingNumber
      if (payeeDetails.postalCode) this.payeePostCd = payeeDetails.postalCode
      if (payeeDetails.city) this.payeeCity = payeeDetails.city
      if (payeeDetails.countrySubDivision) this.payeeCtrySubDvsn = payeeDetails.countrySubDivision
      if (payeeDetails.country) this.payeeCtry = this.selectedPayee.country
    }
    event.$on('open_userProfile', (isOpen) => {
      this.openPayee = false
    })
    event.$on('is_SEPA_TransferComplete', (status) => {
      this.isTransferComplete = status
    })
    event.$on('IS_REVIEW_CLEAR', async ({ type }) => {
      this.reviewScreen = false
      if (type === 'Reset') {
        setTimeout(() => {
          this.resetPage()
        }, 100)
      }
      await this.getListofAccounts()
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.enableOTPToAddPayee && this.showOTPScreen) {
        this.modalConfig.otp.enableSave = false
        this.addNewPayee()
      } else {
        this.modalConfig.otp.enableSave = true
      }
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    if (this.appSettingsNA.enableNominatedAccountFeatures) {
      this.isOwnAccLinked = 'own'
    }
    this.userId = JSON.parse(sessionStorage.getItem('customerCode')) || JSON.parse(sessionStorage.getItem('userId'))
    this.corporateId = JSON.parse(sessionStorage.getItem('corporateId'))
    this.userCorporates = JSON.parse(sessionStorage.getItem('userCorporates'))
    this.defaultCorporateCode = JSON.parse(sessionStorage.getItem('defaultCorporateCode'))
    this.corpName = this.userCorporates?.find(c => c.corporateCode === this.defaultCorporateCode)?.corporateDescription ?? ''
    const permissions = store.getters['profileStore/profileData']?.permissions
    this.isAddPayeePermitted.sepa = this.isSmeRoleBasedAccessEnabled() ? permissions?.includes('ADD_AND_DELETE_SEPA_PAYEES') : true
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successModal.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  computed: {
    payeeSearchFilter () {
      if (!this.beneficiaryList?.length) return []

      const matchesSearch = (item) => {
        if (!this.searchPayee) return true
        return (
          item.name.toLowerCase().includes(this.searchPayee.toLowerCase()) ||
          item.accountIdentification.toLowerCase().includes(this.searchPayee.toLowerCase())
        )
      }

      return this.beneficiaryList
        .filter(item =>
          item.paymentSystem === 'STEP2' &&
          item.currency === this.form?.selectedAccount?.currency &&
          (this.showLinkedAccounts === 0 ? item.ownAccount === true : item.ownAccount === false) &&
          matchesSearch(item)
        )
    },
    filteredSourceAccounts () {
      if (!this.listOfAccounts.length) return []

      const accounts = this.listOfAccounts.filter((item) => {
        const isDebitAllowed = item.postingsRestriction !== 'DEBIT'
        const isAccountTypeAllowed = ['SVGS', 'CACC'].includes(item.accountType)
        const isSameCurrency = item.currency === this.SEPAPaymentTemplate.currency
        const isAccountOwnershipAllowed = !(item.accountOwnership === 'JOINT' &&
          this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList.includes(item.modeOfOperation.code))

        return isDebitAllowed && isAccountTypeAllowed && isSameCurrency && isAccountOwnershipAllowed
      })

      return this.getFilteredAccounts(accounts)
    },
    filterARI () {
      const restrictionsToCheck = ['DEBIT', 'DEBITCREDIT', 'ACCSTOPENQ', 'ACCSTOPENQWITHREF']

      if (!this.listOfAccounts.length) return []

      const accounts = this.listOfAccounts.filter(account => {
        const isNotRestricted = !restrictionsToCheck.includes(account.postingsRestriction)
        const isSameCurrency = account.currency === this.SEPAPaymentTemplate.currency
        const isAccountTypeAllowed = ['SVGS', 'CACC'].includes(account.accountType)

        return isNotRestricted && isSameCurrency && isAccountTypeAllowed
      })

      return this.getFilteredAccounts(accounts)
    },
    showFilters () {
      return !this.appSettingsNA.enableTransferFundsOnlyToOwnAccounts && !this.isNominatedAccount
    },
    hasValidDocuments () {
      if (this.isFuturePayment) return true

      if (!this.settings.documentsRequired && this.supplementaryDocuments.length === 0) return true

      return this.supplementaryDocuments.length > 0 && !this.supplementaryDocuments.some(file => file.error)
    },
    settings () {
      return {
        docCategory: this.$appSettings.defaultConfigurations.supplementaryDocuments.docCategory,
        docType: this.$appSettings.defaultConfigurations.supplementaryDocuments.docType,
        documentsRequired: this.$appSettings.defaultConfigurations.supplementaryDocuments.required,
        businessType: this.$appSettings.defaultConfigurations.supplementaryDocuments.SEPA.businessType,
        maxUploadRetryCount: this.$appSettings.defaultConfigurations.supplementaryDocuments.maxUploadRetryCount
      }
    },
    retry () {
      return this.failureDialog.retryCount < this.settings.maxUploadRetryCount
    },
    oneTimePayment () {
      return this.paymentMode === 0
    },
    isFuturePayment () {
      return (this.oneTimePayment ? this.formattedDate : this.repeatFormattedDate) !== this.currentDate
    },
    dataList () {
      const { amt, chargeAmount, currency, transferNote, toAccName, payeeAccountName, toAcc, bicCode } = this.successResponse
      return [
        {
          label: 'fromLabel',
          value: this.isQuickPay ? this.form.quickSelectedAccount?.selectedAccountText : this.form.selectedAccount?.selectedAccountText,
          subValue: this.isQuickPay ? this.form.quickSelectedAccount?.selectedAccountHintText : this.form.selectedAccount?.selectedAccountHintText
        },
        {
          label: this.isQuickPay ? 'toAccIBAN' : 'toLabel',
          value: this.isQuickPay ? toAccName : payeeAccountName,
          subValue: !this.isQuickPay ? `(${toAcc})` : `(${toAcc} | ${bicCode})`
        },
        {
          label: 'amountLabel',
          value: this.formatAmount(amt, currency)
        },
        {
          label: 'charge',
          value: this.formatAmount(chargeAmount, currency)
        },
        {
          label: 'quickPaymentDateLabel',
          value: this.$formatter.formatDate(moment().format(YMD))
        },
        {
          label: 'reviewNoteLabel',
          value: transferNote
        }
      ]
    },
    getPaymentSuccessDialogConfig () {
      return {
        ...this.modalConfig.successModal,
        enabled: this.showSuccessDialog,
        dataDetails: this.dataList,
        body: this.$t('paymentSuccessDialog.yourTransactionReference') + ' ' + this.successResponse.referenceID
      }
    },
    supplementaryConfig () {
      const { SEPA } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments
      return {
        enabled: SEPA.enabled,
        required: SEPA.required,
        maxFileSizeInMB: SEPA.maxFileSizeInMB,
        maxFileUploadCount: SEPA.maxFileUploadCount,
        validFileTypes: SEPA.validFileTypes
      }
    },
    isSupplementaryDocumentEnabled () {
      return this.isSmeLogin && this.supplementaryConfig.enabled
    },
    hasValidSupplementaryDocuments () {
      const { required } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments.SEPA
      const documents = this.payeeSupplementaryDocuments || []

      const allDocumentsValid = documents.every(doc => !doc.error)
      const hasDocuments = documents.length > 0

      if (!this.isSupplementaryDocumentEnabled) {
        return true
      }
      if (required) {
        return hasDocuments && allDocumentsValid
      }
      return allDocumentsValid
    },
    isAddPayeeDisabled () {
      return !this.isPayeeFormValid || !this.hasValidSupplementaryDocuments || !this.isAddPayeeAddressFormValid
    },
    isAddPayeeAddressEnabled () {
      return this.appSettings.enableInternationalPayeeAddressFields && this.isSmeLogin
    }
  },
  methods: {
    setPayeeCountry () {
      event.$emit('setCountry', this.payeeForm.reEnteredToAccount.slice(0, 2))
    },
    numbersOnly (e) {
      if (['e', '+', '-'].includes(e.key)) {
        e.preventDefault()
      }
    },
    clearBICError () {
      /** Capitalize text on to account input field */
      this.quickPayment.toAccount = this.quickPayment.toAccount && this.quickPayment.toAccount.toUpperCase()

      if (this.quickPayment.invalidIBAN) {
        this.quickPayment.invalidIBAN = false
      }
      /** Clear and reset the BIC Code field if the field already has a value and user tries to edit the To IBAN */
      if (this.quickPayment.bicCode) {
        this.quickPayment.bicCode = ''
        this.$refs.quickPayBicCode.reset()
      }
    },
    getIBAN () {
      if (this.payeeForm.reEnteredToAccount && this.payeeForm.reEnteredToAccount.length) {
        return `IBAN-${this.payeeForm.reEnteredToAccount.length}`
      }
    },
    filterKey (e) {
      const key = e.key
      if (key === '.' || key === 'e') { return e.preventDefault() }
    },
    formatIBAN () {
      /** Capitalize text on to account input field */
      if (this.payeeForm.reEnteredToAccount) {
        this.payeeForm.reEnteredToAccount = this.payeeForm.reEnteredToAccount.toUpperCase()
      }
      if (this.payeeForm.reEnteredToAccount && this.payeeForm.reEnteredToAccount.length && this.payeeForm.reEnteredToAccount.length > 3) {
        let data = ''
        data = this.payeeForm.reEnteredToAccount.replace(/\s+/g, '')
        const res = data.substr(0, 4) + ' ' + data.substr(4, 4) + ' ' + data.substr(8, 4) + ' ' + data.substr(12, 4) + ' ' + data.substr(16, 4) + ' ' + data.substr(20, 4) + ' ' + data.substr(24, 4)
        if (res.trim().length > 28) {
          this.payeeForm.reEnteredToAccount = res.trim().substring(0, 34)
        } else {
          this.payeeForm.reEnteredToAccount = res.trim()
        }
      }
    },
    showDivider (index, array) {
      return array.length ? index + 1 < array.length : false
    },
    restrictDecimal (val) {
      if (val && val.length) {
        // Restrict the input to 2 decimal places
        const newAmt = val.match(/^\d+\.?\d{0,2}/)
        this.isQuickPay ? this.quickPayment.transferAmount = newAmt : this.transferAmount = newAmt
      }
    },
    maskSortCode (code) {
      let maskedCode = ''
      if (code) {
        const sortCode = code.toString()
        for (let i = 0; i < sortCode.length; i++) {
          if (i % 2 === 0) {
            maskedCode = maskedCode + sortCode.substr(i, 2)
          } else if (i !== sortCode.length - 1) {
            maskedCode = maskedCode + '-'
          }
        }
      }
      return code ? maskedCode : ''
    },
    removeMasking (code) {
      return code ? code.replace(/-/g, '') : ''
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    repeatUpdateDateOTP () {
      this.formattedDateOTP = this.$formatter.formatDate(this.formattedDate)
    },
    async resetPage () {
      // clears all fields
      if (this.$refs.form) {
        this.$refs.form.reset()
        this.fromDate = moment().format(YMD)
        this.formattedDateOTP = await this.$formatter.formatDate(this.fromDate)
      }
      if (this.$refs.quickPaymentForm) {
        this.$refs.quickPaymentForm.reset()
        this.quickPayment.formattedDate = await this.$formatter.formatDate(moment().format(YMD))
      }
      // resets screens
      this.reviewScreen = false
      this.isFormValid = false
      this.isAccountBalance = false
      this.quickPayment.isFormValid = false
      this.quickPayment.isAccountBalance = false
      this.selectedPayeeSortCode = ''
      this.payeeAccountName = ''
      this.openPayee = false
      this.supplementaryDocuments.length = 0
      setTimeout(() => {
        this.resetDate()
        this.repeatResetDate()
      }, 100)
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: this.transactionId },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.$t('proofOfPayment.value.processing') }
      ]
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: this.transactionId
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
    },
    onClosePayeeDrawer () {
      if (!this.enablePayeeForm) {
        this.openPayee = !this.openPayee
      }
      if (this.enablePayeeForm) {
        this.enablePayeeForm = false
        // clears all fields
        if (this.$refs.payeeForm) {
          this.$refs.payeeForm.reset()
        }
      }
    },
    onAddPayee () {
      if (this.enableEBAVCheckForAddPayee) {
        this.accountEbavCheck()
      } else this.createPayeeInit()
    },
    createPayeeInit () {
      if (this.enableOTPToAddPayee) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.addNewPayee()
      }
    },
    async accountEbavCheck () {
      try {
        const validatePayload = {
          accountNumber: this.payeeForm.reEnteredToAccount.replace(/\s+/g, ''),
          sortCode: this.removeMasking(this.payeeForm.sortCode),
          partyId: this.isSmeLogin ? this.corporateId : this.userId
        }
        const response = await commonService.accountEbavCheck(validatePayload)
        if (response && !response.causes && response.externalBankAccountVerification) {
          this.createPayeeInit()
        } else {
          this.dispatchError({ content: this.$t('domesticPayments.validatePayeeError') })
        }
      } catch (e) {
        console.log(e)
      }
    },
    onSortCodeSelect (data) {
      this.enablePayeeForm = true
      this.payeeForm.sortCode = data.nationalid
      this.payeeForm.branchName = this.convertToCapitalisedSentence(
        data.instname
      )
    },
    onOtpModalClose () {
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    buildFormData (payload) {
      const {
        businessType,
        docCategory,
        docType
      } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments.SEPA

      const form = new FormData()
      form.append('businessType', businessType)
      form.append('businessValue', payload.beneficiaryId)
      form.append('docCategory', docCategory)
      form.append('docType', docType)
      form.append('userId', payload.customerId)

      const filenames = []
      this.payeeSupplementaryDocuments.forEach(file => {
        form.append('document', file)
        filenames.push(file.name)
      })
      form.append('docReferences', JSON.stringify(filenames))
      form.append('payload', JSON.stringify(payload))

      return form
    },
    async addNewPayee () {
      try {
        const accountIdentification = this.payeeForm.reEnteredToAccount.replace(/\s+/g, '')
        let payeePayload = {
          beneficiaryId: uuidv4().replace(/-/g, '').substring(0, 30),
          customerId: JSON.parse(sessionStorage.getItem('username')),
          name: this.payeeForm.accountName,
          accountIdentificationType: 'IBAN',
          accountIdentification,
          country: accountIdentification.slice(0, 2),
          currency: this.SEPAPaymentTemplate.currency,
          paymentSystem: 'STEP2',
          bankIdentifier: this.payeeForm.sortCode,
          ownAccount: this.isOwnAccLinked === 'own'
        }

        // Add Payee Address details
        if (this.isAddPayeeAddressEnabled) {
          const payeeAddressData = Object.fromEntries(
            Object.entries(this.payeeAddressFormData).filter(([_, value]) => value != null && value !== '')
          )

          payeePayload = {
            ...payeePayload,
            ...payeeAddressData
          }
        }
        const form = this.isSupplementaryDocumentEnabled ? this.buildFormData(payeePayload) : ''
        const response = this.isSupplementaryDocumentEnabled
          ? await commonService.uploadAndCreatePayee('sepa', form)
          : await commonService.createBeneficiaryAccount(payeePayload)
        if (response && !response.causes && response.details.customerId) {
          this.onOtpModalClose()
          this.$refs.payeeForm.reset()
          this.enablePayeeForm = false
          this.$store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('internationalPayments.addPayeeSuccessMsg'),
              type: 'success',
              component: 'dob-snackbar'
            }
          })
          setTimeout(() => {
            this.getExistingPayeeList()
          }, 100)
        } else {
          if (response?.internalType === 'OTP-ERROR') {
            this.modalConfig.otp.enabled = true
            event.$emit('otp_validation_failed', response)
            return
          }
          this.onOtpModalClose()
          if (response?.causes?.[0]?.code === '20600463') {
            this.dispatchError({ content: this.$t('systemMessages.customMessages.20600463.message'), title: this.$t('systemMessages.customMessages.20600463.title') })
          } else {
            this.dispatchError({ content: this.$t('internationalPayments.addNewPayeeError'), title: 'Error' })
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    async getBICFromIBAN () {
      try {
        const toAccount = this.isQuickPay && this.quickPayment.toAccount ? this.quickPayment.toAccount.replace(/\s+/g, '') : this.payeeForm.reEnteredToAccount.replace(/\s+/g, '')
        if (toAccount.length) {
          const response = await commonService.getBICFromIBAN(toAccount)
          if (response && response.valid && !response.causes) {
            if (this.payeeForm.reEnteredToAccount) {
              this.payeeForm.sortCode = response.ibanBic
            } else if (this.quickPayment.toAccount) {
              this.quickPayment.bicCode = response.ibanBic
            }
          } else {
            if (this.isQuickPay) this.quickPayment.invalidIBAN = true
            this.dispatchError({ content: this.$t('internationalPayments.deriveBICError') })
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getListofAccounts () {
      this.loaderEnabled = true
      const accounts = await preload.getAllCASAWithBalance(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.loaderEnabled = false
      this.listOfAccounts = this.getFilteredAccounts(accounts)
    },
    togglePayee (index) {
      this.payeeAccount = index.accountIdentification
      this.payeeAccountName = index.accountIdentification
      this.selectedPayeeSortCode = index.bankIdentifier
      this.selectedPayee = index
      this.payeeList = index.name
      if (this.isAddPayeeAddressEnabled) {
        this.payeeAddrType = index.addressType
        this.payeeAddrLine = index.addressLine
        this.payeeStrtNm = index.street
        this.payeeBldgNb = index.buildingNumber
        this.payeePostCd = index.postalCode
        this.payeeCity = index.city
        this.payeeCtrySubDvsn = index.countrySubDivision
        this.payeeCtry = index.country
      }
      this.openPayee = !this.openPayee
      this.verifyAccount('selectPayee')
    },
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    async getAccountBalances (accountNumber) {
      const response = await commonService.getAccountBalances(accountNumber)
      if (response.balances) {
        return response.balances
      }
    },
    listPayee () {
      if (!this.linkedNominatedAccDetails.payawayAccountId) {
        if (!this.openPayee) {
          this.getExistingPayeeList()
        }
        this.openPayee = !this.openPayee
      }
    },
    clearSearch () {
      this.search = ''
    },
    updateDate () {
      this.formattedDate = this.$formatter.formatDate(this.fromDate)
    },
    resetDate () {
      this.formattedDate = this.fromDate
    },
    verifyAccount (triggeredFrom = undefined) {
      this.listOfAccounts.forEach((acc) => {
        const selectedType = this.selectedAccountNumber
          ? 'default'
          : 'quickPayment'
        switch (selectedType) {
          case 'quickPayment':
            if (this.quickPayment.selectedAccountNumber && acc.accountId === this.quickPayment.selectedAccountNumber) {
              this.selectedAccountNumberCurrency = acc.currency
              this.quickPayment.selectedAccount = acc
              this.isFormAccountsQP = this.quickPayment.selectedAccountNumber === this.quickPayment.toAccount
              if (this.quickPayment.transferAmount.toString().replace(',', '.')) {
                this.verifyBalance()
                this.$refs.qpAmountField.validate()
              }
            }
            break
          default:
            if (acc.accountId === this.selectedAccountNumber) {
              this.selectedAccount = acc
              this.selectedAccountNumber === this.payeeAccount
                ? (this.isFormAccounts = true)
                : (this.isFormAccounts = false)
              this.isAccountBalance = false
            }
            break
        }
      })
    },
    verifyPayee () {
      if (this.selectedPayee && this.selectedPayee?.currency !== this.form?.selectedAccount?.currency) {
        this.payeeList = ''
        this.payeeAccountName = ''
        this.selectedPayeeSortCode = ''
        this.selectedPayee = null
      }
    },
    handleSourceInput () {
      this.verifyAccount()
      this.verifyPayee()
    },
    verifyBalance () {
      const selectedType = this.selectedAccountNumber
        ? 'default'
        : 'quickPayment'
      switch (selectedType) {
        case 'quickPayment':
          this.quickPayment.transferAmount.toString().replace(',', '.') > 0 &&
          this.quickPayment.transferAmount.toString().replace(',', '.') <=
            (this.quickPayment.selectedAccount
              ? this.quickPayment.selectedAccount.balance
              : '')
            ? (this.quickPayment.isAccountBalance = false)
            : (this.quickPayment.isAccountBalance = true)
          break
        default: {
          const temp = this.selectedAccount ? this.selectedAccount.balance : ''
          if (this.transferAmount > 0 &&
          this.transferAmount <= temp) {
            this.isAccountBalance = false
          } else this.isAccountBalance = true
          break
        }
      }
    },
    nextValidate (type) {
      this.reviewScreen = true
      switch (type) {
        case 'quickPayment':
          this.$refs.quickPaymentForm.validate()
          this.payload = {
            fromAcc: this.quickPayment.selectedAccountNumber,
            fromAccIBAN: this.quickPayment.selectedAccountNumber.iban,
            toAcc: this.quickPayment.toAccount,
            toAccName: this.quickPayment.toAcctName,
            bicCode: this.quickPayment.bicCode,
            transferAmount: this.quickPayment.transferAmount[0],
            paymentFrequency: 'ONCE',
            frequencyMonths: false,
            startDate: this.quickPayment.fromDate,
            transferNote: this.quickPayment.transferNote || `${this.SEPAPaymentTemplate.currency} Payment STEP2`,
            internationalPaymentCharges: this.isFuturePayment ? undefined : this.internationalPaymentCharges,
            currencyFormat: this.SEPAPaymentTemplate.currency,
            fromAccount: this.form.quickSelectedAccount
          }
          this.viewOnly = {
            fromAccType: this.quickPayment.selectedAccount.accountType,
            senderAccName: this.quickPayment.toAccount
          }
          break
        default:
          this.$refs.form.validate()
          this.selectedAccountNumber === this.payeeAccount
            ? (this.isFormAccounts = true)
            : (this.isFormAccounts = false)
          this.payload = {
            fromAcc: this.selectedAccountNumber,
            fromAccIBAN: this.selectedAccount.iban,
            toAcc: this.payeeAccount,
            transferAmount: this.transferAmount[0],
            paymentFrequency: this.oneTimePayment ? 'ONCE' : this.paymentFrequency.val,
            frequencyMonths: this.oneTimePayment ? false : this.frequencyMonths,
            startDate: this.oneTimePayment ? this.formattedDate : this.repeatFormattedDate,
            transferNote: this.transferNote || `${this.SEPAPaymentTemplate.currency} Payment STEP2`,
            internationalPaymentCharges: this.oneTimePayment ? this.isFuturePayment ? undefined : this.internationalPaymentCharges : undefined,
            payeeSortCode: this.selectedPayeeSortCode,
            currencyFormat: this.SEPAPaymentTemplate.currency,
            fromAccount: this.form.selectedAccount
          }
          this.viewOnly = {
            fromAccType: this.selectedAccount.accountType,
            senderAccName: `${this.payeeAccount} | ${this.selectedPayeeSortCode}`,
            payeeAccountName: this.payeeList
          }
          break
      }
      this.payload.supplementaryDocuments = this.isFuturePayment ? [] : this.supplementaryDocuments
    },
    isAnyInputsFilled () {
      if (!this.oneTimePayment) {
        return Boolean(
          this.selectedAccountNumber ||
            this.payeeAccount ||
            (this.transferAmount && this.transferAmount.length) ||
            this.paymentFrequency ||
            this.frequencyMonths
        )
      } else {
        return Boolean(
          this.selectedAccountNumber ||
            this.payeeAccount ||
            (this.transferAmount && this.transferAmount.length)
        )
      }
    },
    async getExistingPayeeList () {
      try {
        const response = await commonService.getCustomBeneficiaries(
          JSON.parse(sessionStorage.getItem('username'))
        )
        if (response && response.items) {
          this.beneficiaryList = response.items
        }
      } catch (e) {
        console.log(e)
      }
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    getPayeeDetails () {
      const self = this
      for (const item of this.beneficiaryList) {
        if (item.accountIdentification === self.payeeAccount) return item
      }
      return false
    },
    repeatUpdateDate () {
      this.repeatFromDate = this.$formatter.formatDate(this.repeatFormattedDate)
    },
    repeatResetDate () {
      this.repeatFromDate = this.$formatter.formatDate(this.repeatMinAllowedDate)
      this.repeatFormattedDate = (moment(moment(this.repeatFromDate, YMD, true)).isValid()) ? this.repeatFromDate : (this.repeatFromDate ? moment(this.repeatFromDate, 'DD-MM-YYYY').format(YMD) : '')
    },
    onNextButton () {
      if ((this.oneTimePayment || this.isQuickPay) && this.currentDate === this.formattedDate) {
        this.validateSEPAtransfer()
      } else this.nextValidate()
    },
    setDownloadData () {
      this.downloadDataDetails = []
      this.downloadDataDetails.push(
        {
          label: 'fromAcc',
          value: this.payload?.fromAccount?.selectedAccountText,
          subValue: this.$formatter.maskNumber(this.payload?.fromAcc)
        },
        {
          label: 'toAcc',
          value: this.viewOnly?.payeeAccountName,
          subValue: this.isQuickPay
            ? `(${this.$formatter.maskNumber(this.payload?.toAcc)} | ${this.payload?.bicCode})`
            : `(${this.$formatter.maskNumber(this.payload?.toAcc)} | ${this.payload?.payeeSortCode})`
        },
        {
          label: 'amount',
          value: this.$formatter.currency.format(
            this.payload?.transferAmount,
            this.payload?.currencyFormat
          )
        },
        {
          label: 'paymentDate',
          value: this.isFuturePayment
            ? this.$formatter.formatDate(this.payload?.startDate)
            : this.paymentTime ? this.$formatter.formatDateTime(this.paymentDate,
              {
                outputFormat: `${this.displayDateFormat} hh:mm:ss A`
              }
            )
              : this.$formatter.formatDate(this.payload?.startDate)
        },
        {
          label: 'charges',
          value: this.$formatter.currency.format(
            this.payload?.internationalPaymentCharges,
            this.payload?.currencyFormat
          )
        }
      )
    },
    async validateSEPAtransfer () {
      this.endToEndId = `DOB-${this.SEPAPaymentTemplate.currency}-${Math.floor(Date.now() / 1000)}`
      try {
        const d = moment()
        const toAccDetails = !this.isQuickPay ? await this.getPayeeDetails() : ''
        const customerDetails = store.getters['profileStore/profileData'].customerDetails
        const isValidStatus = ['ACSP', 'ACCP']
        const body = getSepaRequestBody()

        body.CstmrCdtTrfInitn.GrpHdr.CreDtTm = d.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        const PmtInf = body.CstmrCdtTrfInitn.PmtInf[0]
        PmtInf.ReqdExctnDt = d.format('YYYY-MM-DD')
        PmtInf.Dbtr.Nm = this.isSmeLogin ? this.corpName : customerDetails.fullName
        PmtInf.Dbtr.Id.PrvtId.Othr[0].Id = this.isSmeLogin ? this.corporateId : customerDetails.partyID
        PmtInf.DbtrAcct.Id.Othr.Id = this.isQuickPay ? this.quickPayment.selectedAccountNumber : this.selectedAccountNumber

        const { PmtId, Amt, CdtrAgt, Cdtr, CdtrAcct } = PmtInf.CdtTrfTxInf[0]
        PmtId.InstrId = this.isQuickPay && (this.quickPayment.transferNote && this.quickPayment.transferNote.length) ? this.quickPayment.transferNote.split(' ').join('-')
          : this.transferNote && this.transferNote.length
            ? this.transferNote.split(' ').join('-')
            : `${this.SEPAPaymentTemplate.currency}-Payment-STEP2`
        PmtId.EndToEndId = this.endToEndId

        Amt.InstdAmt.Amt = this.isQuickPay ? +this.quickPayment.transferAmount[0] : +this.transferAmount[0]
        Amt.InstdAmt.Ccy = this.SEPAPaymentTemplate.currency
        Amt.EqvtAmt.CcyOfTrf = this.SEPAPaymentTemplate.currency
        CdtrAgt.FinInstnId.BICFI = this.isQuickPay ? this.quickPayment.bicCode : toAccDetails.bankIdentifier
        Cdtr.Nm = this.isQuickPay ? this.quickPayment.toAcctName : toAccDetails.name
        Cdtr.PstlAdr.Ctry = this.isQuickPay ? this.quickPayment.toAccount.slice(0, 2) : this.payeeAccount.slice(0, 2)
        if (this.isAddPayeeAddressEnabled && !this.isQuickPay) {
          if (this.payeeAddrType) Cdtr.PstlAdr.AdrTp = this.mapPayeeAddrType()
          if (this.payeeStrtNm) Cdtr.PstlAdr.StrtNm = this.payeeStrtNm
          if (this.payeeBldgNb) Cdtr.PstlAdr.BldgNb = this.payeeBldgNb
          if (this.payeePostCd) Cdtr.PstlAdr.PstCd = this.payeePostCd
          if (this.payeeCity) Cdtr.PstlAdr.TwnNm = this.payeeCity
          if (this.payeeCtrySubDvsn) Cdtr.PstlAdr.CtrySubDvsn = this.payeeCtrySubDvsn
        }
        CdtrAcct.Id.IBAN = this.isQuickPay ? this.quickPayment.toAccount : this.payeeAccount
        const resp = await commonService.validateSEPAtransfer(body)
        if (
          resp &&
          resp.Document &&
          isValidStatus.includes(
            resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
              .TxSts
          )
        ) {
          this.internationalPaymentCharges =
            resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
              .Charges.Amt || 0
          // pass param if quick payment
          this.isQuickPay ? this.nextValidate('quickPayment') : this.nextValidate()
        } else {
          if (resp?.causes?.[0]?.code === '20600063') {
            this.dispatchError({ content: this.$t('systemMessages.customMessages.20600063.message'), title: this.$t('systemMessages.customMessages.20600063.title') })
          } else if (resp?.causes?.[0]?.code === '20600464') {
            this.dispatchError({ content: this.$t(resp.causes[0].message.replace('Beneficiary', this.$t('systemMessages.customMessages.20600464.message'))), title: this.$t('systemMessages.customMessages.20600464.title') })
          } else if (resp?.causes && resp?.causes[0]?.code === '20600123') {
            this.dispatchError({ content: this.$t('systemMessages.customMessages.20600123.message'), title: this.$t('systemMessages.customMessages.20600123.title') })
          } else {
            this.dispatchError({ content: this.$t('systemMessages.customMessages.20600087.message') })
          }
          this.reviewScreen = false
        }
      } catch (e) {
        console.log(e)
      }
    },
    mapPayeeAddrType () {
      const addressTypeMapping = {
        'DELIVER-TO': 'DLVY',
        'MAIL-TO': 'MLTO',
        'PO-BOX': 'PBOX',
        BUSINESS: 'BIZZ',
        POSTAL: 'ADDR',
        RESIDENTIAL: 'HOME'
      }
      return addressTypeMapping[this.payeeAddrType] || 'ADDR'
    },
    async initiateSEPAtransfer () {
      const { businessType, docCategory, docType } = this.settings
      const hasSupplementaryDocuments = Array.isArray(this.supplementaryDocuments) && this.supplementaryDocuments.length > 0
      let form

      try {
        const d = moment()
        const toAccDetails = !this.isQuickPay ? await this.getPayeeDetails() : ''
        const customerDetails = store.getters['profileStore/profileData'].customerDetails
        const isValidStatus = ['ACSP', 'ACCP']
        const body = getSepaRequestBody()

        body.InitiationContext.PreCalculatedCharges = {
          amount: this.internationalPaymentCharges || 0,
          currency: this.SEPAPaymentTemplate.currency,
          suppressAdditionalCharges: !this.internationalPaymentCharges
        }

        body.CstmrCdtTrfInitn.GrpHdr.CreDtTm = d.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')

        const PmtInf = body.CstmrCdtTrfInitn.PmtInf[0]
        PmtInf.ReqdExctnDt = d.format('YYYY-MM-DD')
        PmtInf.Dbtr.Nm = this.isSmeLogin ? this.corpName : customerDetails.fullName
        PmtInf.Dbtr.Id.PrvtId.Othr[0].Id = this.isSmeLogin ? this.corporateId : customerDetails.partyID
        PmtInf.DbtrAcct.Id.Othr.Id = this.isQuickPay ? this.quickPayment.selectedAccountNumber : this.selectedAccountNumber
        PmtInf.ChrgsAcct = {
          Id: {
            Othr: {
              Id: this.isQuickPay ? this.quickPayment.selectedAccountNumber : this.selectedAccountNumber
            }
          }
        }

        const { PmtId, Amt, CdtrAgt, Cdtr, CdtrAcct } = PmtInf.CdtTrfTxInf[0]
        PmtId.InstrId = this.isQuickPay && (this.quickPayment.transferNote && this.quickPayment.transferNote.length) ? this.quickPayment.transferNote.split(' ').join('-')
          : this.transferNote && this.transferNote.length
            ? this.transferNote.split(' ').join('-')
            : 'EUR-Payment-STEP2'
        PmtId.EndToEndId = this.endToEndId

        Amt.InstdAmt.Amt = this.isQuickPay ? this.quickPayment.transferAmount[0] : this.transferAmount[0]
        Amt.InstdAmt.Ccy = this.SEPAPaymentTemplate.currency
        Amt.EqvtAmt.CcyOfTrf = this.SEPAPaymentTemplate.currency
        CdtrAgt.FinInstnId.BICFI = this.isQuickPay ? this.quickPayment.bicCode : this.selectedPayeeSortCode
        Cdtr.Nm = this.isQuickPay ? this.quickPayment.toAcctName : toAccDetails.name
        Cdtr.PstlAdr.Ctry = this.isQuickPay ? this.quickPayment.toAccount.slice(0, 2) : this.payeeAccount.slice(0, 2)
        CdtrAcct.Id.IBAN = this.isQuickPay ? this.quickPayment.toAccount : this.payeeAccount

        if (this.isAddPayeeAddressEnabled && !this.isQuickPay) {
          if (this.payeeAddrType) Cdtr.PstlAdr.AdrTp = this.mapPayeeAddrType()
          if (this.payeeStrtNm) Cdtr.PstlAdr.StrtNm = this.payeeStrtNm
          if (this.payeeBldgNb) Cdtr.PstlAdr.BldgNb = this.payeeBldgNb
          if (this.payeePostCd) Cdtr.PstlAdr.PstCd = this.payeePostCd
          if (this.payeeCity) Cdtr.PstlAdr.TwnNm = this.payeeCity
          if (this.payeeCtrySubDvsn) Cdtr.PstlAdr.CtrySubDvsn = this.payeeCtrySubDvsn
        }

        if (hasSupplementaryDocuments) {
          form = new FormData()
          form.append('businessType', businessType)
          form.append('businessValue', this.endToEndId)
          form.append('docCategory', docCategory)
          form.append('docType', docType)
          form.append('userId', this.isSmeLogin ? this.corporateId : customerDetails.partyID)
          this.supplementaryDocuments.forEach(file => form.append('document', file))
          form.append('payment-payload', JSON.stringify(body))
        }

        this.loaderEnabled = true
        const resp = hasSupplementaryDocuments ? await commonService.uploadAndInitiateTransfer('sepa', form) : await commonService.initiateSEPAtransfer(body)
        this.loaderEnabled = false
        if (
          resp &&
          resp.Document &&
          isValidStatus.includes(
            resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
              .TxSts
          )
        ) {
          this.transactionId = resp?.Document?.
            CstmrPmtStsRpt?.OrgnlPmtInfAndSts[0]?.TxInfAndSts[0]?.OrgnlEndToEndId
          let isoTimeString = resp.Document.CstmrPmtStsRpt.OrgnlGrpInfAndSts.OrgnlCreDtTm;
          if (isoTimeString) {
            let date = new Date(isoTimeString)
            this.paymentTime = date?.toISOString().substr(11, 8)
          }
          this.paymentDate = resp.Document.CstmrPmtStsRpt.OrgnlGrpInfAndSts.OrgnlCreDtTm
          this.setDownloadData()
          const successData = this.isQuickPay ? {
            fromAcc: this.quickPayment.selectedAccountNumber,
            fromAccIBAN: this.quickPayment.selectedAccountNumber.iban,
            toAcc: this.quickPayment.toAccount,
            toAccName: this.quickPayment.toAcctName,
            amt: this.quickPayment.transferAmount[0],
            bicCode: this.quickPayment.bicCode,
            transferNote: this.quickPayment.transferNote || `${this.SEPAPaymentTemplate.currency} Payment STEP2`
          } : {
            fromAcc: this.selectedAccountNumber,
            fromAccIBAN: this.selectedAccount.iban,
            toAcc: `${this.payeeAccount} | ${this.selectedPayeeSortCode}`,
            amt: this.transferAmount[0],
            transferNote:
              this.transferNote ||
              `${this.SEPAPaymentTemplate.currency} Payment STEP2`,
            payeeAccountName: this.payeeList
          }
          const successResponse = {
            paymentType: 'SEPA',
            chargeAmount: this.internationalPaymentCharges,
            currency: this.SEPAPaymentTemplate.currency,
            paymentTime: this.paymentTime,
            referenceID:
              resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
                .OrgnlEndToEndId,
            fromAccType: this.currentTab === 0 ? this.selectedAccount.accountType : this.quickPayment.selectedAccount.accountType,
            ...successData
          }
          this.successResponse = successResponse
          this.isLeavingRoute = false
          this.showSuccessDialog = true
        } else {
          if (resp && resp.internalType === 'OTP-ERROR') {
            event.$emit('otp_validation_failed', resp)
            return
          }
          event.$emit('close_otp')
          if (resp?.causes && resp?.causes[0]?.code === '20600123') {
            this.dispatchError({ content: this.$t('systemMessages.customMessages.20600123.message'), title: this.$t('systemMessages.customMessages.20600123.title') })
            event.$emit('reset_OTPField', true)
            return
          } else {
            this.failureDialog.show = true
            this.failureDialog.errorList.push(this.$t('systemMessages.customMessages.10500001.message'))
            // await deleteSupplementaryDocuments(this.supplementaryDocuments, 'Failed SEPA transaction')
            event.$emit('reset_OTPField', true)
            this.isInitiateSepaFailed = true
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    resetNApayeeDetails () {
      this.linkedNominatedAccDetails = {}
    },
    async getLinkedAccountDetails () {
      const self = this
      const response = await commonService.getLinkedAccountDetails(
        this.selectedAccountNumber
      )
      if (response && response.payawayAccountId) {
        await this.getExistingPayeeList()
        this.loaderEnabled = true
        self.linkedNominatedAccDetails = response
        setTimeout(() => {
          const res = self.beneficiaryList.filter((item) => {
            return item.accountIdentification === response.payawayAccountId
          })
          if (res && res.length) {
            self.payeeAccountName = response.payawayAccountId
            self.payeeAccount = response.payawayAccountId
            self.payeeList = res[0].name
            self.selectedPayeeSortCode = res[0].bankIdentifier
          } else this.resetNApayeeDetails()
          this.loaderEnabled = false
        }, 500)
      } else this.resetNApayeeDetails()
    },
    async verifyNominatedAccount () {
      if (this.selectedAccountNumber && this.appSettingsNA.enableNominatedAccountFeatures && this.appSettingsNA.enablePaymentsOnlyToNominatedAccounts) {
        const savingsCashISA = this.filteredSourceAccounts.filter((item) => {
          return (
            item.accountType === 'SVGS' ||
            item.accountType === 'TXSV'
          )
        }).map((value) => { return value.accountId })
        this.isNominatedAccount = savingsCashISA.includes(this.selectedAccountNumber)
        const ownAccounts = this.beneficiaryList.filter(item => {
          return item.ownAccount
        }).map((value) => { return value.accountIdentification })
        if (this.isNominatedAccount) {
          this.showLinkedAccounts = 0
          this.openPayee = false
          const isToAccValid = ownAccounts.includes(this.payeeAccountName)
          if (!isToAccValid) {
            this.payeeAccountName = ''
            this.payeeAccount = ''
            this.payeeList = ''
            this.selectedPayeeSortCode = ''
          }
          await this.getLinkedAccountDetails()
        } else this.resetNApayeeDetails()
        return this.isNominatedAccount
      }
      return false
    },
    isBalValid () {
      if ((this.selectedAccountNumber || this.quickPayment.selectedAccountNumber) && this.transferAmount && this.transferAmount.length) {
        const selectedType = this.selectedAccountNumber
          ? 'default'
          : 'quickPayment'
        let temp = ''
        switch (selectedType) {
          case 'quickPayment':
            temp = this.quickPayment.selectedAccount ? this.quickPayment.selectedAccount.balance : ''
            if (this.quickPayment.transferAmount[0] > 0 &&
          this.quickPayment.transferAmount[0] <= temp) {
              return false
            } else return true
          default:
            temp = this.selectedAccount ? this.selectedAccount.balance : ''
            if (this.transferAmount[0] > 0 &&
          this.transferAmount[0] <= temp) {
              return false
            } else return true
        }
      }
    },
    async quickPaymentFormReset () {
      if (this.$refs.quickPaymentForm) {
        this.$refs.quickPaymentForm.reset()
        this.quickPayment.formattedDate = await this.$formatter.formatDate(moment().format(YMD))
      }
    },
    onTabChanged () {
      this.supplementaryDocuments.length = 0
      this.selectedAccount = null
      this.form.selectedAccount = null
      this.form.quickSelectedAccount = null
    },
    dispatchError ({ content, title = 'Error' }) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title,
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          content,
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    formatAmount (amount, ccy) {
      return this.$formatter.currency.format(amount, ccy)
    },
    async handleCreateNewTransfer () {
      this.showSuccessDialog = false
      this.reviewScreen = false
      this.supplementaryDocuments.length = 0
      setTimeout(() => { this.resetPage() }, 100)
      await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    },
    async handleGotoDashboard () {
      this.showSuccessDialog = false
      this.reviewScreen = false
      this.loaderEnabled = true
      await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
      this.isTransferComplete = true
      this.$router.push('/home')
    },
    handleGoBack () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
      this.failureDialog.retryCount = 0
    },
    handleRetryTransfer () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
      this.failureDialog.retryCount++
      // this.initiateSEPAtransfer()
      event.$emit('retry_transfer')
    },
    handleCancelTransfer () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
      this.reviewScreen = false
      this.failureDialog.retryCount = 0
      this.supplementaryDocuments.length = 0
      setTimeout(() => { this.resetPage() }, 100)
    },
    documentDetails () {
      return this.supplementaryDocuments.map(file => ({
        documentId: file.documentId
      }))
    },
    onPaymentModeChanged () {
      this.selectedAccount = null
      this.form.selectedAccount = null
      this.form.quickSelectedAccount = null
    },
    showAddPayeeForm () {
      this.enablePayeeForm = true
      this.payeeSupplementaryDocuments = []
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isTransferComplete && this.isAnyInputsFilled()) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else if (to.path === '/confirmInternationalPayments') {
        this.to = to
        this.isLeavingRoute = false
        next()
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  },
  watch: {
    currentTab () {
      this.currentTab === 0 ? this.quickPaymentFormReset() : this.resetPage()
      this.isQuickPay = this.currentTab === 1
    },
    'form.selectedAccount' () {
      this.selectedAccountNumber = this.form.selectedAccount?.accountId ?? ''
      this.selectedAccount = this.form.selectedAccount
    },
    'form.quickSelectedAccount' () {
      this.quickPayment.selectedAccountNumber = this.form.quickSelectedAccount?.accountId ?? ''
      this.quickPayment.selectedAccount = this.form.quickSelectedAccount
    },
    showOTPScreen () {
      if (this.enableOTPToAddPayee && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
    event.$off('download_payment_proof')
  }
}
</script>
